import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { CustomerDashboardNotificationsPage } from './customer-dashboard-notifications'

const CustomerDashboardNotificationsPageRaw = ({ match }) => {
  return (
    <Switch>
      <Route render={() => <CustomerDashboardNotificationsPage />} />
    </Switch>
  )
}

export const CustomerDashboardNotificationsRoutes = withRouter(CustomerDashboardNotificationsPageRaw)
